import ownersipAreasService from "../shared/services/ownersipAreasService";

const REQUEST_OWNERSHIPAREAS = "REQUEST_OWNERSHIPAREAS";
const RESPONSE_OWNERSHIPAREAS = "RESPONSE_OWNERSHIPAREAS";
const REQUEST_OWNERSHIPAREAS_FAILURE = "REQUEST_OWNERSHIPAREAS_FAILURE";

const requestOwnershipAreasAction = () => {
  return {
    type: REQUEST_OWNERSHIPAREAS,
  };
};

const responseOwnershipAreasAction = (data) => {
  return {
    type: RESPONSE_OWNERSHIPAREAS,
    data,
  };
};

const requestOwnershipAreasFailureAction = (errors) => {
  return {
    type: REQUEST_OWNERSHIPAREAS_FAILURE,
    errors,
  };
};

const getOwnershipAreas = () => {
  return (dispatch) => {
    dispatch(requestOwnershipAreasAction());

    ownersipAreasService
      .getOwnershipAreas()
      .then((result) => {
        dispatch(responseOwnershipAreasAction(result.data));
      })
      .catch((error) => {
        dispatch(requestOwnershipAreasFailureAction(error.response));
      });
  };
};

export { REQUEST_OWNERSHIPAREAS, RESPONSE_OWNERSHIPAREAS, REQUEST_OWNERSHIPAREAS_FAILURE, getOwnershipAreas };
